import type { Book, ValueChart, PerformanceResult } from "@/schemas";
import {
  useBooksQuery,
  usePerformanceQuery,
  useValueChartQuery,
} from "./queries";

interface PortfolioDataLoading {
  books: boolean;
  chart: boolean;
  performance: boolean;
}

interface UsePortfolioDataResult {
  books: Book[];
  chartData: ValueChart | null;
  performanceData: PerformanceResult | null;
  loading: PortfolioDataLoading;
}

/**
 * Hook to fetch and manage portfolio data (books, value chart, performance).
 */
export function usePortfolioData(
  selectedBookId: string,
  period: string
): UsePortfolioDataResult {
  const booksQuery = useBooksQuery();
  const chartQuery = useValueChartQuery(selectedBookId, period);
  const performanceQuery = usePerformanceQuery(selectedBookId, period);

  const loading: PortfolioDataLoading = {
    books: booksQuery.isLoading,
    chart: chartQuery.isLoading,
    performance: performanceQuery.isLoading,
  };

  return {
    books: (booksQuery.data as Book[]) ?? [],
    chartData: (chartQuery.data as ValueChart | null) ?? null,
    performanceData: (performanceQuery.data as PerformanceResult | null) ?? null,
    loading,
  };
}
